<template>
  <div class="expert-info">
    <BasicAvatar
      class="expert-info__avatar"
      :image="expert.avatar"
      size="medium-smaller"
      :href="link"
      roundness="full"
    />
    <div
      class="expert-info__text"
      :class="bem('expert-info__text', { centered: !expert.position, noWrap })"
    >
      <BasicLink
        appearance="dark"
        class="expert-info__link"
        :href="link"
      >
        {{ expert.title }}
      </BasicLink>
      <BasicText
        v-if="expert.position"
        class="expert-info__position"
        :class="bem('expert-info__position', { noWrap })"
        color="muted"
        size="sm"
      >
        {{ expert.position }}
      </BasicText>
    </div>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  import BasicAvatar from 'src/components/BasicAvatar/BasicAvatar.vue';
  import BasicLink from 'src/components/BasicLink/BasicLink.vue';
  import BasicText from 'src/components/text/BasicText/BasicText.vue';

  export default {
    name: 'ExpertInfo',
    components: { BasicText, BasicAvatar, BasicLink },
    props: {
      expert: {
        type: Object,
        required: true,
      },
      noWrap: Boolean,
    },
    methods: {
      bem,
    },
    computed: {
      link() {
        return `/${this.expert.login}`;
      },
    },
  };
</script>
